(function(){
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
var els=document.querySelectorAll('.reveal');
if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});}
else{var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.1});
els.forEach(function(e,i){e.style.transitionDelay=((i%4)*70)+'ms';io.observe(e);});}

/* gallery thumbs */
var main=document.getElementById('ppMain');
document.querySelectorAll('.th').forEach(function(b){b.addEventListener('click',function(){
if(!main)return;main.removeAttribute('srcset');main.src=b.getAttribute('data-full');
document.querySelectorAll('.th').forEach(function(x){x.classList.remove('on')});b.classList.add('on');});});

/* scroll progress bar + timeline fill */
var bar=document.createElement('div');bar.className='prog';document.body.appendChild(bar);
var tls=document.querySelectorAll('.tl');
var ticking=false;
function onScroll(){
var h=document.documentElement.scrollHeight-innerHeight;
bar.style.transform='scaleX('+(h>0?Math.min(1,scrollY/h):0)+')';
tls.forEach(function(t){
var r=t.getBoundingClientRect(),vh=innerHeight;
var p=Math.max(0,Math.min(1,(vh*.75-r.top)/(r.height+vh*.1)));
t.style.setProperty('--p',p.toFixed(3));
var kids=t.children;
for(var i=0;i<kids.length;i++){
var k=kids[i].getBoundingClientRect();
kids[i].classList.toggle('on',k.top<vh*.72);
}});
upd&&upd();ticking=false;}
addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(onScroll);}},{passive:true});
addEventListener('resize',onScroll);onScroll();

/* sticky buy bar on mobile: show once main button leaves the screen */
var upd;var btn=document.getElementById('mainBtn'),sbar=document.getElementById('sbar');
if(btn&&sbar&&'IntersectionObserver' in window){
var seen=false,cta=document.querySelector('.cta');
var vis={btn:true,cta:false};
upd=function(){var show=!vis.btn&&!vis.cta&&scrollY>240;sbar.classList.toggle('show',show);sbar.setAttribute('aria-hidden',show?'false':'true');
sbar.querySelectorAll('button,a').forEach(function(x){x.tabIndex=show?0:-1;});};
new IntersectionObserver(function(es){vis.btn=es[0].isIntersecting;upd();}).observe(btn);
if(cta)new IntersectionObserver(function(es){vis.cta=es[0].isIntersecting;upd();}).observe(cta);
}
})();
